import {createSelector} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import { IOsaState} from "../../state/osa/osa.state";


export const selectScannigs = createSelector(
  (state: IAppState) => state.osa,
  (state:IOsaState) => state.reports.scanning
);

/*
export const selectFillRate = createSelector(
  (state: IAppState) => state.reports.insights,
  (state: IReportsInsightsState) => state.reportFillRate
);


 */
